import { schemaMixin } from '@witkac/jschema';
import previewComponents from '../components/preview/previewComponents';
let components = null;

// nie przekazujemy komponentów bo rejestrujemy je globalnie
/*

if ((typeof window !== "undefined") && (window.Vue)) {
  //są zarejestrowane globalnie
  components = null;

} else {
  components = previewComponents;
}
*/



// import { fixSchemaDefaultOptions } from '../utils/JsonSchema';
// fixSchemaDefaultOptions.arrayItemGuidField = 'Guid';

export default {
  mixins: [schemaMixin],
  components: components,
  props: ['datamodel', 'external'],
  data() {
    let data = {};
    return {
      model: this.$props.datamodel,
    };
  },

  beforeCreate() {
    const props = this.$options.propsData;

    if (props.external) {
      this.$options.external = props.external;
      delete props.external;
    }
  },
  created() {
    console.log('previewMixin created');

  },
  mounted() {
    if (typeof window !== "undefined") {

      window.vm = this;
    }
  }
};
